// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cube[data-v-3ea92d0a]{height:100px!important;@media (min-width:1024px){height:235px!important}}.hero-box[data-v-3ea92d0a]{position:absolute;right:-97px;top:-28px;@media (min-width:1024px){right:-94px;top:-90px}&.animation[data-v-3ea92d0a]{animation:roll-3ea92d0a 5s}}@keyframes roll-3ea92d0a{0%{transform:rotate(0)}to{transform:rotate(2turn)}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
